import { Helmet } from 'react-helmet';
import { capture } from '../../../utils/analytics';
import { hapticsImpactLight } from '../../../utils/haptics';
import {
  addSentryBreadcrumb,
  captureSentryMessage,
} from '../../../utils/sentry';
import { Button } from '../../ui/button';

const clearDataAndRefresh = () => {
  capture('hard_refresh_clicked');
  captureSentryMessage('Hard refresh clicked');
  localStorage.clear();
  sessionStorage.clear();

  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0].trim();
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
  });

  window.location.reload();
};

const AssetLoadErrorView = () => (
  <div className="page-not-found">
    {/* A transient chunk failure must never be indexed as the page's content
        (Google rendered one as the /pricing description, ORA-890). */}
    <Helmet>
      <meta name="robots" content="noindex" />
    </Helmet>
    <h1>Ora needs a refresh</h1>
    <p>
      We couldn&apos;t load the latest app files. This usually happens if Ora
      updated while this page was still open.
    </p>
    <Button
      className="!w-96"
      onClick={() => {
        addSentryBreadcrumb({
          message: 'User clicked refresh from asset-load error page',
          level: 'info',
          category: 'user-interaction',
        });

        window.location.reload();
        hapticsImpactLight();
      }}
    >
      Refresh Ora
    </Button>

    <div className="escape-hatch">
      <Button
        className="-ml-3"
        variant="link"
        onClick={() => {
          addSentryBreadcrumb({
            message:
              'User clicked escape hatch from asset-load error page - clearing all data',
            level: 'warning',
            category: 'user-interaction',
          });

          hapticsImpactLight();
          clearDataAndRefresh();
        }}
      >
        Still stuck? Clear data &amp; refresh
      </Button>
    </div>
  </div>
);

export default AssetLoadErrorView;
